
<div class="ihd-app-loader-content">
    <div class="ihd-loader ihd-app-loader-logo">
        <div class="ihd-app-spinner">
            <svg class="svg" viewBox="50 50 100 100">
                <circle class="app" cx=100 cy=100 r=46 ></circle>
            </svg>
        </div>
    </div>
</div>
<div class="ihd-app-loader-content msg">{{config?.title | translate}}</div>
